import { BUILDING_TYPE_ID } from './utils/helpers/constants';

export const SCHEMA_CONTEXT = 'http://schema.org';

export enum SchemaOrgType {
  BreadcrumbList = 'BreadcrumbList',
  ListItem = 'ListItem',
  Product = 'Product',
  Offer = 'Offer',
  QuantitativeValue = 'QuantitativeValue',
  PostalAddress = 'PostalAddress',
  Place = 'Place',
  Apartment = 'Apartment',
  House = 'House',
  RealEstateAgent = 'RealEstateAgent',
  OpeningHoursSpecification = 'OpeningHoursSpecification',
  ImageObject = 'ImageObject',
  GeoCoordinates = 'GeoCoordinates'
}

export const BuildingTypeMap: Record<string, SchemaOrgType> = {
  [BUILDING_TYPE_ID.HOUSE]: SchemaOrgType.House,
  [BUILDING_TYPE_ID.FLAT_ALL]: SchemaOrgType.Apartment,
  [BUILDING_TYPE_ID.FLAT_NEW]: SchemaOrgType.Apartment,
  [BUILDING_TYPE_ID.FLAT_SECONDARY]: SchemaOrgType.Apartment
};
